import { html } from '@design.estate/dees-element';

export const demoFunc = () => html`
  <div style="display: flex; gap: 8px; align-items: center;">
    <dees-badge .text=${'Default'}></dees-badge>
    <dees-badge .type=${'primary'} .text=${'Primary'}></dees-badge>
    <dees-badge .type=${'success'} .text=${'Success'}></dees-badge>
    <dees-badge .type=${'warning'} .text=${'Warning'}></dees-badge>
    <dees-badge .type=${'error'} .text=${'Error'}></dees-badge>
    <dees-badge .type=${'primary'} .rounded=${true} .text=${'Rounded'}></dees-badge>
  </div>
`;